<script lang="ts">
	import { fade } from 'svelte/transition';
	import { attrValue } from '../utils/html';

	export let title = '';
	export let content = '';

	export let classNames: string;
	export let id: string | null = null;
	export let textCenter = true;
	export let width: string;
	export let placement = 'top';
	export let variant: 'hint' | 'default' | 'error' = 'default';
	export let fixedTooltipArrowPosition;
	export let tooltipNode = null;
</script>

<div
	class:text-center={textCenter}
	class:pointer-events-none={!$$slots.default}
	class={attrValue(['tooltip ', classNames, width])}
	class:error={variant === 'error'}
	class:hint={variant === 'hint'}
	data-popper-placement={placement}
	{id}
	bind:this={tooltipNode}
	in:fade
	out:fade
>
	<div class="inner">
		{#if title}
			{@html title}
		{/if}
		{#if $$slots.default}
			<slot />
		{:else if content}
			<div class="text-sm italic first-letter:uppercase text-left">
				{@html content}
			</div>
		{/if}
	</div>
	<div
		class="arrow {fixedTooltipArrowPosition ? 'left-1/2 transform -translate-x-1/2' : ''}"
		data-popper-arrow
	/>
</div>

<style lang="postcss">
	.tooltip {
		--arrow-distance: calc(theme('width.1') * -1);
		--arrow-bg: theme('colors.black');
		--tooltip-bg: theme('colors.black');
		--tooltip-text: theme('colors.white');
		--tooltip-padding: theme('spacing.2');
		@apply z-tooltip relative max-w-[500px];
	}

	.inner {
		position: relative;
		z-index: 1;
		background-color: var(--tooltip-bg);
		color: var(--tooltip-text);
		padding: var(--tooltip-padding);
		border-radius: theme('borderRadius.DEFAULT');
		@apply text-sm;
	}

	.arrow {
		visibility: hidden;
	}
	.arrow,
	.arrow:before {
		position: absolute;
		z-index: -1;
		width: theme('width.2');
		height: theme('width.2');
	}

	.arrow:before {
		content: '';
		visibility: visible;
		transform: rotate(45deg);
		transform-origin: center center;
		top: 0;
		left: 0;
		background-color: var(--arrow-bg);
	}

	[data-popper-placement^='top'] .arrow {
		bottom: var(--arrow-distance);
	}

	[data-popper-placement^='bottom'] .arrow {
		top: var(--arrow-distance);
	}

	[data-popper-placement^='left'] .arrow {
		right: var(--arrow-distance);
	}

	[data-popper-placement^='right'] .arrow {
		left: var(--arrow-distance);
	}

	.error {
		--tooltip-bg: theme('colors.white');
		--tooltip-text: theme('colors.black');
		--arrow-bg: theme('colors.danger');
		@apply mt-2 inline-block border rounded border-danger;
	}

	.error .inner {
		@apply ml-auto;
	}

	.error .arrow {
		right: 1.3rem;
	}

	.hint {
		--tooltip-bg: theme('colors.white');
		--tooltip-text: theme('colors.grey-light');
		--tooltip-padding: theme('spacing.1');
		--arrow-bg: theme('colors.grey-lighter');
		@apply max-w-7;
	}

	.hint .inner {
		@apply inline-block border border-grey-lighter;
	}

	.hint .arrow {
		@apply right-4;
	}
</style>
